import { Form } from "antd";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";
import { DynamicPropertyGroupPropertiesTable } from "../index";

export const DynamicPropertyGroupPropertiesTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    // We use the id from the URL to determine if we are in a create or edit mode.
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <DynamicPropertyGroupPropertiesTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
